import { PaperclipIcon } from 'lucide-react'
import { useRef } from 'react'

import { Button } from '@/components/ui'
import { FileItem } from '@/modules/upload/components/FileDropzone/FileItem'
import { ATTACHMENT_ACCEPT } from '../attachments'

interface AttachmentPickerButtonProps {
  onPick: (files: FileList | null) => void
  size?: 'sm' | 'md'
}

export const AttachmentPickerButton = ({
  onPick,
  size = 'md',
}: AttachmentPickerButtonProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ATTACHMENT_ACCEPT}
        className="hidden"
        onChange={(event) => {
          onPick(event.target.files)
          event.target.value = ''
        }}
      />
      <Button
        theme="ghost"
        size={size}
        isIcon
        aria-label="Attach files"
        onClick={() => inputRef.current?.click()}
      >
        <PaperclipIcon />
      </Button>
    </>
  )
}

interface PendingAttachmentListProps {
  files: File[]
  onRemove: (index: number) => void
}

export const PendingAttachmentList = ({
  files,
  onRemove,
}: PendingAttachmentListProps) => {
  if (files.length === 0) return null

  return (
    <div className="rounded-lg border border-border px-3 py-1">
      {files.map((file, index) => (
        <FileItem
          key={`${file.name}-${file.size}-${file.lastModified}`}
          item={file}
          onRemove={() => onRemove(index)}
        />
      ))}
    </div>
  )
}
